import { tripTemplate } from '@/dataStructures';
import { objectSet } from '@/core';

function setTripTemplates(state, tripTemplates) {
	state.tripTemplates = tripTemplates.map(
		tt => ({
			...tripTemplate(),
			...tt,
		})
	);
}

function setTemplateToEdit(state, templateDetails) {
	state.dirty = false;
	for (let key in state.templateDetails) {
		state.templateDetails[key] = templateDetails[key] === undefined ? undefined : JSON.parse(JSON.stringify(templateDetails[key]));
	}
}

function resetDetails(state) {
	state.templateDetails = tripTemplate();
	state.generatedTrips = [];
	state.dirty = false;
}

function set(state, { path, value }) {
	if (!path) throw new Error('Path needed for set mutation');
	objectSet(state, path, value);
}

function setDetails(state, { path, value }) {
	state.dirty = true;
	if (path) objectSet(state.templateDetails, path, value);
	else Object.assign(state.templateDetails, value);
}

function setFrequency(state, { path, value }) {
	state.dirty = true;
	if (path) objectSet(state.templateDetails.frequency, path, value);
	else Object.assign(state.templateDetails.frequency, value);
}

const getCurrentValidationState = ({ isInvalid, eta, etd, fromAddress, toAddress, vendor, name, legs }) => {
	if (!isInvalid) return false;
	if (legs.reduce((acc, v) => acc || v.isInvalid, false)) return true;
	return eta || etd || fromAddress || toAddress || vendor || name;
};

function setErrors(state, { path, value }) {
	if (path) {
		objectSet(state.errors, path, value);
		if (value) state.errors.isInvalid = true;
		else state.errors.isInvalid = getCurrentValidationState(state.errors);
	} else {
		Object.assign(state.errors, value);
	}
}

function setGeneratedTrips(state, trips) {
	state.generatedTrips = trips;
	state.templateDetails.generatedTrips = trips.map(t => t.id);
}

function setNextTrip(state, nextTrip) {
	state.templateDetails.nextTrip = nextTrip;
}

export default {
	setTripTemplates,
	setTemplateToEdit,
	resetDetails,
	set,
	setDetails,
	setFrequency,
	setErrors,
	setGeneratedTrips,
	setNextTrip,
};
